import React, { useEffect, useRef, useState } from 'react';
import { shape, string } from 'prop-types';
import { Box, Tooltip, Typography } from '@mui/material';

const OverflowTypography = props => {
  const { text, typographyProps } = props;
  const [hoverStatus, setHover] = useState(false);
  const textElementRef = useRef();

  const compareSize = () => {
    const compare = textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
    setHover(compare);
  };

  // compare once and add resize listener on "componentDidMount"
  useEffect(() => {
    compareSize();
    window.addEventListener('resize', compareSize);
    return () => {
      window.removeEventListener('resize', compareSize);
    };
  }, []);

  return (
    <Tooltip disableHoverListener={!hoverStatus} interactive="true" title={text}>
      <Box
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        <Typography ref={textElementRef} {...typographyProps}>
          {text}
        </Typography>
      </Box>
    </Tooltip>
  );
};

OverflowTypography.propTypes = {
  text: string.isRequired,
  typographyProps: shape({}).isRequired,
};

export default OverflowTypography;
